import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'

import {
    Breadcrumbs,
    Typography,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';

import {
    MdChevronLeft,
    MdMoreHoriz
} from 'react-icons/md';

import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md';

import { useNavigate } from 'react-router-dom'; // <-- added for programmatic navigation

import styles from './CrmBreadcrumbs.module.css';

const initialItems = [
    { label: '', href: '/' },
    { label: '', href: '/' }
];

const CrmBreadcrumbs = ({
    selectedCrmModule,
    firstRecord
}) => {
    // const [items, setItems] = useState(initialItems);
    const navigationPath = useSelector(s => s.crm.navigationPath);
    const [anchorEl, setAnchorEl] = useState(null);
    const breadcrumbRef = useRef();
    const navigate = useNavigate(); // <-- initialize navigate

    // useEffect(() => {
    //     if (firstRecord && selectedCrmModule) {
    //         setItems([
    //             {
    //                 label: selectedCrmModule.label,
    //                 href: `/crm/${selectedCrmModule.name}/records/`,
    //             },
    //             {
    //                 label: firstRecord.crmName,
    //                 href: `/crm/${selectedCrmModule.name}/records/${firstRecord._id}`
    //             }
    //         ])
    //     }
    // }, [firstRecord?._id,firstRecord?.crmName, selectedCrmModule])

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    // const handleBack = () => {
    //     if (items.length > 1) setItems((prev) => prev.slice(0, -1));
    // };

    // const handleForward = () => {
    //     const newLabel = `עמוד ${items.length + 1}`;
    //     const newHref = `/page/${items.length + 1}`;
    //     setItems((prev) => [...prev, { label: newLabel, href: newHref }]);
    // };

    // const MAX_VISIBLE_ITEMS = 15;

    // let visibleItems = [...items];
    // let hiddenItems = [];

    // if (items.length > MAX_VISIBLE_ITEMS) {
    //     const endCount = MAX_VISIBLE_ITEMS - 2; // one for first, one for ellipsis
    //     const endItems = items.slice(items.length - endCount);
    //     hiddenItems = items.slice(1, items.length - endCount);
    //     visibleItems = [items[0], 'ellipsis', ...endItems];
    // }
    const MAX_VISIBLE_ITEMS = 15;
    let visibleItems = [...navigationPath];
    let hiddenItems  = [];
    
    if (navigationPath.length > MAX_VISIBLE_ITEMS) {
      const endCount   = MAX_VISIBLE_ITEMS - 2;          // first + ellipsis + tail
      const endItems   = navigationPath.slice(-endCount);
      hiddenItems      = navigationPath.slice(1, -endCount);
      visibleItems     = [navigationPath[0], 'ellipsis', ...endItems];
    }

    const handleNavigate = (href) => {
        navigate(href);
    };

    return (
        <div className={styles.breadcrumbsContainer}>
            {/* <IconButton onClick={handleBack} className={styles.navArrowButton}>
                <MdArrowForwardIos size={20} style={{color:'white'}}/>
            </IconButton> */}

            <div ref={breadcrumbRef} className={styles.breadcrumbRoot}>
                <Breadcrumbs
                    separator={<MdChevronLeft size={16} color="white" />}
                    aria-label="breadcrumb"
                >
                    {visibleItems.map((item, index) => {
                        if (item === 'ellipsis') {
                            return (
                                <div key="ellipsis">
                                    <IconButton
                                        size="small"
                                        className={styles.ellipsisButton}
                                        onClick={handleMenuOpen}
                                        style={{ color: 'white' }}
                                    >
                                        <MdMoreHoriz size={20} style={{ color: 'white' }} />
                                    </IconButton>
                                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                                        {hiddenItems.map((hiddenItem, idx) => (
                                            <MenuItem
                                                key={idx}
                                                onClick={() => { handleNavigate(hiddenItem.href); handleMenuClose(); }}
                                                className={styles.ellipsisMenuItem}
                                            >
                                                {hiddenItem.label}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </div>
                            );
                        }

                        const isLast = index === visibleItems.length - 1;
                        return isLast ? (
                            <Typography key={index} className={styles.breadcrumbCurrent}>
                                {item.label}
                            </Typography>
                        ) : (
                            <span
                                key={index}
                                onClick={() => handleNavigate(item.href)}
                                className={styles.breadcrumbLink}
                                style={{ cursor: 'pointer' }}
                            >
                                {item.label}
                            </span>
                        );
                    })}
                </Breadcrumbs>
            </div>

            {/* <IconButton onClick={handleForward} className={styles.navArrowButton} style={{color:'white'}}>
                <MdArrowBackIosNew size={20} />
            </IconButton> */}
        </div>
    );
}

export default CrmBreadcrumbs;
